export const passCodes = [
    '^studna$', // 2
    '^straka$', // 4
    '^sokol$', // 5
    '', // 6 - unused
    '^[a|b]$', // 8
    '^49$', // 9
    '^pelik[a|á]n$', // 10
    '^hv[e|ě]zd[y|a|u]$', // 12
    '^84$', // 13
    '^[z|ž]lut[a|á|e|é|y|ý]$', // 15
    '^ku[z|ž]ely$', // 16
    '^6$', // 18
    '^(u|ke)k[r|ř][i|í][z|ž]ku$', // 19
    '^n[a|á]m[e|ě]st[i|í]$', // 20
    '^d[a|á]lrovn[e|ě]$', // 22
    '^w$', // 23
    '^bakla[z|ž][a|á]n$', // 25
    '^topinambur$', // 26
    '^(labu(t|ť))((a|,)?)(holub(ice)?)|(holub(ice)?)((a|,)?)(labu(t|ť))|(labu(t|ť))|(holub(ice)?)$', // 27
    '^(k[o|ó]djsou)?no[z|ž]e$', // 28
    '^(pes)|(psa)|(pse)$', // 29
    '^9$', // 30
    '^orlice$', // 31
    '^1968$', // 32
    '^s[i|í][t|ť]ovk[a|u]$', // 33
    '^1891$', // 35
    '^(jd[e|ě]te)?(na)?tvrz$', // 36
    '^(region[a|á]ln[i|í])?muzeum$', // 37
    '^(erb|znak)$', // 38
];

export const commonMistakeCodes = [
    '^orel$', // 5
    '^labu[t|ť]$', // 5
    '^holub(ice)?$', // 10
    '^tvrz$', // 37
];
